// extracted by css-extract-rspack-plugin
export default {"TooltipItem":"TooltipItem--BtxIj","TooltipItemLabel":"TooltipItemLabel--K87lH"};